import React, { useEffect, useState } from 'react';
import './declarePeriod.scss';
import { DECLARE_PERFORMANCE_PERIOD } from '../../../Constants/strings';
import Filter from './Filters/filters';
import { fetchPerformamncePeriodDetails } from './declarePeriodUtil';
import NoData from '../../SkillMap/Dashboard/noData';
import DataTable from './DataTable/dataTable';
import { CircularProgress } from '@mui/material';

const DeclarePeriod = () => {
  const [performancePeriodList, setPerformancePeriodList] = useState([]);
  const [selectedYear, setSelectedYear] = useState([]);
  const [selectedPerformanceType, setSelectedPerformanceType] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isFilteredListEmpty, setIsFilteredListEmpty] = useState(false);

  useEffect(() => {
    // API call to fetch performance master details
    setLoading(true);
    fetchPerformamncePeriodDetails()
      .then(data => {
        setPerformancePeriodList(data);
        setFilteredList(data); // Assign filteredList the same value as performancePeriodList
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (selectedYear.length > 0 || selectedPerformanceType.length > 0) {
      const selectedYearNames = selectedYear.map(year => year.name);
      const selectedPerformanceTypeNames = selectedPerformanceType.map(type => type.name);
      const filtered = performancePeriodList.filter(item =>
        (selectedYearNames.length === 0 || selectedYearNames.includes(item.year.toString()))
        && (selectedPerformanceTypeNames.length === 0 || selectedPerformanceTypeNames.includes(item.cycleName)),
      );
      setFilteredList(filtered);
      setIsFilteredListEmpty(filtered.length === 0);
    } else {
      setFilteredList(performancePeriodList);
      setIsFilteredListEmpty(false);
    }
  }, [selectedYear, selectedPerformanceType, performancePeriodList]);

  const updatePerformanceCycleList = () => {
    fetchPerformamncePeriodDetails()
      .then(data => {
        setPerformancePeriodList(data);
        setFilteredList(data); // Ensure state is updated here
      });
    setSelectedYear([]);
    setSelectedPerformanceType([]);
  };

  return (
    <div className="declare-period-outer-layer">
      <div className="declare-period">
        <h1 className="title-text">{DECLARE_PERFORMANCE_PERIOD.TITLE}</h1>
        <Filter
          filterData={performancePeriodList}
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
          selectedPerformanceType={selectedPerformanceType}
          setSelectedPerformanceType={setSelectedPerformanceType}
          updatePerformanceCycleList={updatePerformanceCycleList}
        />

        {filteredList.length > 0 && !loading && (
          <DataTable
            rows={filteredList}
            setRows={setFilteredList}
            updatePerformanceCycleList={updatePerformanceCycleList}
          />
        )}

        {filteredList.length === 0 && !loading && (
          <NoData
            message={!isFilteredListEmpty
              ? DECLARE_PERFORMANCE_PERIOD.NO_PREVIOUS_RECORDS
              : DECLARE_PERFORMANCE_PERIOD.NO_RECORDS}
            displayImage={true}
          />
        )}

        {loading && (
          <div className="loading-spinner">
            <CircularProgress size={50} />
          </div>
        )}

      </div>
    </div>
  );
};

export default DeclarePeriod;
